export const DEFAULT_Q = { rate: 4.79, qualifyingRate: 6.79, taxPct: 1.0, heat: 150, amort: 25 };

export const money = (n) => (n == null ? "—" : `$${Math.round(n).toLocaleString("en-CA")}`);
export const moneyK = (n) => (n >= 1000000 ? `$${(n / 1000000).toFixed(2)}M` : `$${Math.round(n / 1000)}k`);

export function pmt(principal, annualRate, years) {
  const r = annualRate / 100 / 12, n = years * 12;
  return r ? (principal * r) / (1 - Math.pow(1 + r, -n)) : principal / n;
}

export function minDown(price) {
  if (price <= 500000) return price * 0.05;
  if (price <= 1500000) return 25000 + (price - 500000) * 0.10;
  return price * 0.20;
}

function cmhcRate(ltv) {
  if (ltv > 0.95) return null;
  if (ltv > 0.90) return 0.04;
  if (ltv > 0.85) return 0.031;
  if (ltv > 0.80) return 0.028;
  return 0;
}

// Snapshot's `buying` block → qualifying assumptions (falls back to Alberta defaults).
export function qFromSnap(snap) {
  const b = snap?.buying;
  if (!b) return DEFAULT_Q;
  return { rate: b.rate ?? DEFAULT_Q.rate, qualifyingRate: b.qualifying_rate ?? DEFAULT_Q.qualifyingRate, taxPct: b.property_tax_pct ?? DEFAULT_Q.taxPct, heat: b.monthly_heat ?? DEFAULT_Q.heat, amort: b.amort_years ?? DEFAULT_Q.amort };
}

// Max purchase price under GDS 39% / TDS 44% at the stress-test rate, with Canadian min-down + CMHC rules. Binary search.
export function maxPrice({ income, down, debts = 0, q = DEFAULT_Q }) {
  if (!income || income <= 0 || !down || down <= 0) return 0;
  const gross = income / 12;
  const ok = (price) => {
    if (down < minDown(price)) return false;
    const ltv = (price - down) / price;
    const prem = cmhcRate(ltv);
    if (prem == null) return false;
    const mortgage = Math.max(0, price - down) * (1 + prem);
    const pay = pmt(mortgage, q.qualifyingRate, q.amort);
    const housing = pay + (price * q.taxPct) / 100 / 12 + q.heat;
    return housing / gross <= 0.39 && (housing + debts) / gross <= 0.44;
  };
  let lo = 0, hi = 4000000;
  for (let i = 0; i < 40; i++) { const mid = (lo + hi) / 2; if (ok(mid)) lo = mid; else hi = mid; }
  const price = Math.floor(lo / 1000) * 1000;
  if (price < 50000) return 0;
  const ltv = (price - down) / price;
  const mortgage = (price - down) * (1 + (cmhcRate(ltv) || 0));
  return { price, mortgage, payment: pmt(mortgage, q.rate, q.amort) };
}
